import { h, render, Component } from 'preact';
import { Text} from 'preact-i18n';
import { Modal } from './AeModal';
class AePolicy extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render() {
      return (
      <span className="ae-browse-live search-policy-info">
        <span id="saferAdFreeInfoId" style={{display: (this.props.service !== "shopping" ? "inline-block" : "none")}}>
          <span className="info-wrapper">
            <div style={{"display": "none"}}>
              <Text id="newSearch.saferAdFree">A SAFER, ANONYMOUS, AD-FREE SEARCH</Text>
            </div>
            <span className="info-icon-wrapper">
              <Modal headerKey={"newSearch.saferAdFree"} textKey={"newSearch.saferAdFreeInfo"}/>
            </span>
          </span>
        </span>
        <span id="saferShoppingId" style={{display: (this.props.service === "shopping" ? "inline-block" : "none")}}>
          <span className="info-wrapper">
            <div style={{"display":"none"}}>
             <Text id="newSearch.saferShopping">SAFER SHOPPING</Text>
            </div>
            <Modal headerKey={"newSearch.saferShopping"} textKey={"newSearch.saferShoppingInfo"}/>
          </span>
        </span>
      </span>        
      )
    }
}
export default AePolicy;
